/**
 * 初期状態
 */
type None = {
  type: 'none';
};

/**
 *　ロード中
 */
type Loading = {
  type: 'loading';
};

/**
 *　成功
 */
type Success = {
  type: 'success';
};

/**
 *　失敗
 */
type Error = {
  type: 'error';
  errorMessage: string;
};

/**
 *　ゼロマッチ
 */
type ZeroMatch = {
  type: 'zeroMatch';
};

/**
 * None型かどうかを判定する型ガード
 * @param status - ローディング状態
 */
export const isNone = (status: LoadingState['status']): status is None => {
  return status.type === 'none';
};

/**
 * Loading型かどうかを判定する型ガード
 * @param status - ローディング状態
 */
export const isLoading = (status: LoadingState['status']): status is Loading => {
  return status.type === 'loading';
};

/**
 * Success型かどうかを判定する型ガード
 * @param status - ローディング状態
 */
export const isSuccess = (status: LoadingState['status']): status is Success => {
  return status.type === 'success';
};

/**
 * Error型かどうかを判定する型ガード
 * @param status - ローディング状態
 */
export const isError = (status: LoadingState['status']): status is Error => {
  return status.type === 'error';
};

/**
 * ZeroMatch型かどうかを判定する型ガード
 * @param status - ローディング状態
 */
export const isZeroMatch = (status: LoadingState['status']): status is ZeroMatch => {
  return status.type === 'zeroMatch';
};

/**
 * UI上のローディング状態(NetworkResultとは別)
 */
export interface LoadingState {
  status: None | Loading | Success | Error | ZeroMatch;
}
